import React from 'react';

class BonitaErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[Bonita] Render error caught by boundary:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '16px', opacity: 0.5, textAlign: 'center' }}>
          <p>Bonita is taking a break. Check back soon.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default BonitaErrorBoundary;
